import { ExecutionResults } from '@stratascratch/code-editor/dist/types'
import { tokenUtils } from './authentication'
import { API_URL } from '../constants'
import { Test } from '../components/CodeEditorWidget/TestTabs'

const { getToken } = tokenUtils

interface ExecuteCodeParams {
  code: string
  check_solution: boolean
  question_id: number
  code_type: 1 | 2 | 3 | 4 | 5
}

interface ExecuteAlgorithmicCodeParams {
  code: string
  question_id: number
  code_type: 2
  test?: Test
  check_solution: boolean
}

export interface ExecuteVisualParams {
  code: string
  check_solution: boolean
  question_id: number
  is_expected?: boolean
  no_throttle?: string
  retry?: boolean
}

type Params =
  | ExecuteCodeParams
  | ExecuteAlgorithmicCodeParams
  | ExecuteVisualParams

async function fetchExecution(url: string, params: ExecuteCodeParams | Params) {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  }
  const token = getToken()
  if (token) {
    headers.Authorization = `Token ${token}`
  }

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(params),
  })

  if (response.status === 200) {
    return response.json()
  }
  return null
}

export async function executeAlgorithmicCode(
  params: ExecuteAlgorithmicCodeParams,
) {
  return fetchExecution(`${API_URL}algorithms/execute-code/`, params)
}

export async function executeCode(
  params: ExecuteCodeParams,
): Promise<ExecutionResults | null> {
  return fetchExecution(`${API_URL}execute-sql/`, params)
}

export const executeVisualCode = async (
  params: ExecuteVisualParams,
): Promise<ExecutionResults | null | { error: string; results: null }> => {
  return fetchExecution(`${API_URL}visualizations/execute-code/`, params)
}
